// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"2060":"6676022bec2c8fed565d","5023":"1561faea816cec1f2f1b","6797":"5fcf88ec5be49c9e976e","7021":"c270ee4a229cba73ad10","7342":"140879f2512478fe76cc","8007":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
};